// Right Swipes table component for DealerDashboard
import React from 'react';
import { Card, Button, Badge, Table, Pagination, Typography } from 'antd';
import { ArrowLeftOutlined, DownloadOutlined } from '@ant-design/icons';

const { Text } = Typography;

const RightSwipesTable = ({ 
  filteredRightData, 
  totalRightCount,
  currentPage,
  pageSize,
  onPageChange,
  rightSwipesColumns, 
  onTouchStart, 
  onTouchMove, 
  onTouchEnd, 
  handleExport, 
  setActiveTab 
}) => {
  return (
    <div className="right-swipes-dashboard">
      {/* Header */}
      <div className="page-header">
        <div className="header-left">
          <Button 
            icon={<ArrowLeftOutlined />} 
            type="link" 
            onClick={() => setActiveTab('overview')}
          >
            Back to Deal Status Overview
          </Button>
        </div>
        <div className="header-right">
          <Badge count={totalRightCount} style={{ backgroundColor: '#52c41a' }}>
            <Button 
              icon={<DownloadOutlined />} 
              size="large"
              onClick={handleExport}
              type="primary"
              ghost
            >
              Export
            </Button>
          </Badge>
        </div>
      </div>

      {/* Table */}
      <Card 
        className="table-card"
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        <Table
          columns={rightSwipesColumns}
          dataSource={filteredRightData}
          pagination={false}
          className="right-swipes-table"
        />
      </Card>

      {/* Pagination */}
      <div className="pagination-container">
        <Text type="secondary">
          {`Showing ${totalRightCount === 0 ? 0 : (currentPage - 1) * pageSize + 1} to ${Math.min(currentPage * pageSize, totalRightCount)} from `}
          <span style={{ color: '#52c41a', fontWeight: 700, background: '#f6ffed', padding: '0 6px', borderRadius: '10px' }}>{totalRightCount}</span>
          {` members`}
        </Text>
        <Pagination
          current={currentPage}
          total={totalRightCount}
          pageSize={pageSize}
          showSizeChanger
          pageSizeOptions={["10","20","50"]}
          onChange={onPageChange}
          className="pagination"
        />
      </div>
    </div>
  );
};

export default RightSwipesTable;
